import React, { Component } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core'

class ModalConfirmationRemoveLocation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      archive: false,
    }
  }

  render() {
    const { open, close, confirmUpdate, productData } = this.props
    const { archive } = this.state

    return (
      <Dialog open={open} className={'container-small-modal'}>
        <DialogTitle>Attention</DialogTitle>
        <DialogContent className={'size-small-modal'}>
          <span className={'text-description-adoption-mode'}>
            Removing a location does not actualy remove the product from the shop. It just makes it
            an orphan. If all locations are removed, the master product will be archived.
          </span>
        </DialogContent>
        <DialogActions className="container-buttons-adoption-mode">
          <Button onClick={close} className="button-white-and-red">
            <span className="button-text">Cancel</span>
          </Button>
          {/* <Checkbox
                    checked={archive}
                    onChange={{}}
                    name="archive"
                />
                <p>Set as Archive</p> */}
          <Button
            onClick={() => {
              confirmUpdate(productData)
            }}
            className="button-blue-and-white"
          >
            <span className="button-text">Continue</span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ModalConfirmationRemoveLocation



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/ModalConfirmationRemoveLocation.js